import { Highlight as AlgoliaHighligt } from 'react-instantsearch-dom';
import { THighlightSnippetProps } from 'components/Base/Algolia/types';

const Highlight = ({ hit, attribute }: THighlightSnippetProps): JSX.Element => {
  return <AlgoliaHighligt hit={hit} attribute={attribute} tagName='mark' />;
};

export default Highlight;
